<template>
  <b-modal
    id="modal-seo-setting"
    size="1100"
    body-class="border-top p-0"
    @show="init"
  >
    <template #modal-header="{ close }">
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <div class="modal-title">
              <TitleModal  
                :label="`${$t('engine.managePage.pageAddEdit.seo.lblTab', languageEngine)} : <span style='color:var(--primary);'> ${namePage} </span>`" 
              />
            </div>
            <div
              id="close-modal-seo-setting"
              type="button"
              class="close-modal"
              aria-label="Close"
              @click="close()"
            >
              <i class="fal fa-times"></i>
            </div>
          </div>
        </div>
      </template>
      <div class="wrapper" v-if="data">
        <div class="setting border-right p-gd-2">
          <FocusKeyword 
            v-model="$v.data.properties.seo.focusKeyword.$model" 
            :validate="$v.data.properties.seo.focusKeyword"
          />
          <Keyword 
            v-model="$v.data.properties.seo.keywords.$model" 
            :validate="$v.data.properties.seo.keywords"
          />
          <Title 
            :title_default="''"
            v-model="data.properties.seo.title"
            :focusKeyword="$v.data.properties.seo.focusKeyword.$model"
            :width="titleWidth"
            :mode="mode"
          />
          <Description 
            :desc_default="''"
            v-model="data.properties.seo.description" 
            :focusKeyword="$v.data.properties.seo.focusKeyword.$model"
            :width="descWidth"
            :mode="mode"
          />
          <Tag 
            v-model="$v.data.properties.tags.$model" 
            :validate="$v.data.properties.tags"
          />
        </div>
        <div class="preview pt-gd-2 px-gd-2 pb-0">
          <Preview 
            :data="data.properties.seo"
            :url="data.properties.url"
            :typePage="data.properties.type"
            @setWidth="setWidth"
            @setWidthDesc="setWidthDesc"
            @setMode="setMode"
          />
        </div>
      </div>

      <template #modal-footer="{ close }">
        <b-button variant="blue" @click.prevent="save($event)">
          <i class="far fa-check"></i>
          {{ $t("engine.managePage.pageAddEdit.btnSave", languageEngine) }}
        </b-button>
        <b-button variant="default" @click="close()" >
          <i class="far fa-times"></i>
          {{ $t("engine.managePage.pageAddEdit.btnCancel", languageEngine) }}
        </b-button>
      </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import Title from "./Input/Title";
import Keyword from "./Input/Keyword";
import Description from "./Input/Description";
import FocusKeyword from "./Input/FocusKeyword";
import Tag from "./Input/Tags";
import Preview from "./Preview/Preview";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

import { maxLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      data : null,
      dataFetching : false,
      titleWidth : 0,
      descWidth : 0,
      mode : 'desktop',
    }
  },
  components :{ 
    TitleModal,
    FocusKeyword,
    Description,
    Keyword,
    Tag,
    Title,
    Preview,
  },
  computed: {
    ...mapGetters({
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
    }),
    namePage() {
      return this.data && this.data.properties && this.data.properties.name || '';
    }
  },
  methods : {
    init() {
      this.data = null;
      if(this.id) {
        this.data = this.getData(this.id);
      }
    },
    getData(id) {
      this.dataFetching = true;
      let data = {
        ...JSON.parse(JSON.stringify(this.siteComponents[id])),
      };
      this.dataFetching = false;
      return data;
    },
    setWidth(value) {
      this.titleWidth = parseInt(value);
    },
    setWidthDesc(value) {
      this.descWidth = parseInt(value);
    },
    setMode(value) {
      this.mode = value;
    },
    save() {
      const uniqueKeywords = [...new Set(this.data.properties.seo.keywords)];
      this.data.properties.seo.keywords = uniqueKeywords;
      this.siteComponents[this.id].properties.seo = this.data.properties.seo
      this.siteComponents[this.id].properties.tags = this.data.properties.tags
      this.$store.dispatch("design/snapshot/genSnapshot");
      this.$bvModal.hide('modal-seo-setting');
      this.data = null;
    }
  },
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  validations: {
    data: {
      properties: {
        seo: {
          keywords: {
            maxLength: maxLength(20),
          },
          focusKeyword: {
            maxLength: maxLength(1),
          }
        },
        tags: {
          maxLength: maxLength(20),
        }
      }
    },
  }
}
</script>

<style lang="scss">
#modal-seo-setting {
  .wrapper {
    display: grid;
    grid-template-columns: 380px 720px;
  }
}
</style>